import { useCallback } from 'react';

import { useContinueLoginWithSessionToken as coreUseContinueLoginWithSessionToken } from 'js/hooks/auth/hooks/useContinueLoginWithSessionToken';
import { useRedirectAfterLogin } from './useRedirectAfterLogin';

export const useContinueLoginWithSessionToken = () => {
    const continueLoginWithSessionToken = coreUseContinueLoginWithSessionToken();
    const redirectAfterLogin = useRedirectAfterLogin();

    return useCallback(async ({ userId, userName, sessionToken, ...rest }) => {
        await continueLoginWithSessionToken({ isLoginActionPrevented: true, userId, userName, sessionToken, ...rest });
        redirectAfterLogin();
    }, [continueLoginWithSessionToken, redirectAfterLogin]);
};
